import { Component, OnInit ,ViewContainerRef} from '@angular/core';
import { NovelSeason } from './../../models';
import { AuthService } from './../../service/auth.service';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { Router ,ActivatedRoute} from '@angular/router';
import {AngularFirestore} from '@angular/fire/firestore';
import 'rxjs/add/operator/map';
import { EcomicService } from '../../service/comics/ecomic.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
@Component({
  selector: 'app-e-novel-season-add',
  templateUrl: './e-novel-season-add.component.html',
  styleUrls: ['./e-novel-season-add.component.css']
})
export class ENovelSeasonAddComponent implements OnInit {

  novelseasonForm:FormGroup;
  loading:boolean=false;
  load:boolean=false;
  novels: any;
  showseries: any = false;
  id: any;
  status: any = true;
  season: any = true;
  user: any;
  quater: any = true;

  thumbnail_image: File;
  cover_image: File;
  sponsor_image: File;
  thumbnail_image_url: any;
  cover_image_url: any;
  sponsor_image_url: any;
  coverimageerror: any = false;
  thumbnailimageerror: any = false;
  sponsorimageerror: any = false;
  sponsor_image_url_web: any;
  sponsor_image_web: File;
  sponsorimageerror_Web:any = false;

  constructor(private form:FormBuilder,private router:Router,private afs:AngularFirestore,
    private comicService: EcomicService,private auth: AuthService,private route: ActivatedRoute,
    public toastr: ToastsManager,vcr: ViewContainerRef) {
       this.toastr.setRootViewContainerRef(vcr);}

  ngOnInit() {
    this.novelseasonForm = this.form.group({
      novel_series:['',[Validators.required]],
      season_title:['',[Validators.required]],
      season_description:['',[Validators.required]],
      author_name: ['', [Validators.required]],
      about_author: ['', [Validators.required]],
      IsAllowPointsPurchase:["false",[]],
      thumbnail:['',[]],
      season_cover:['',[]],
      sponsor_logo:['',[]],
      sponsor_url: ['', [Validators.required]],
      status:['InActive',[Validators.required]],
      season:['Season 1',[Validators.required]],
      season_quarter: ['1', [Validators.required]],
      on_going_series:['false', [Validators.required]],
    });

  this.comicService.getnovelserious().then(novelsdata => {
    // subscribing the data from the service
    novelsdata.subscribe(novels => {
      console.log(novels);
      this.novels = novels;
      if (this.route.firstChild) {
        this.route.firstChild.params.subscribe(params => {
          this.id = params['id'];
          if (this.id) {
            this.status = false;
            this.season = false;
            this.quater  = false;
            this.comicService.getsinglenovel(this.id, 'Enovelseason').then(data => {
              // const admindata = data.valueChanges();
              data.subscribe(singleseries => {
                console.log(singleseries);

                const singleadmin = singleseries;
                this.novelseasonForm.get('novel_series').setValue(singleadmin['novel_series']);
                this.novelseasonForm.get('season_title').setValue(singleadmin['season_title']);
                this.novelseasonForm.get('season_description').setValue(singleadmin['season_description']);
                this.novelseasonForm.get('sponsor_url').setValue(singleadmin['sponsor_url']);
                this.novelseasonForm.get('season_quarter').setValue(singleadmin['season_quarter']);
                this.novelseasonForm.get('status').setValue(singleadmin['status']);
                this.novelseasonForm.get('season').setValue(singleadmin['season']);
                this.novelseasonForm.get('about_author').setValue(singleadmin['about_author']);
                this.novelseasonForm.get('author_name').setValue(singleadmin['author_name']);
                this.novelseasonForm.get('IsAllowPointsPurchase').setValue(singleadmin['IsAllowPointsPurchase'] ? String(singleadmin['IsAllowPointsPurchase']): "false");
                this.novelseasonForm.get('on_going_series').setValue(singleadmin['on_going_series'] ? singleadmin['on_going_series'] : 'false');
                this.sponsor_image_url_web = singleseries['sponsor_banner_web'];
                this.thumbnail_image_url = singleseries['thumbnail_image'];
                this.cover_image_url = singleseries['cover_image'];
                this.sponsor_image_url = singleseries['sponsor_image'];
                this.status = true;
                this.season = true;
                this.showseries = true;
                this.quater  = true;
              });
            });
          }
        });
      } else {
        this.novelseasonForm.get('novel_series').setValue(this.novels[0].id);
        this.showseries = true;
        if (!this.id) {
          this.auth.getuser().then(userdetails => {
            this.user = userdetails;
          });
        }
      }
    });
  });
}
async addseason(value, valid) {
  if (valid) {
    this.loading = true;
    console.log(value)
    const season: NovelSeason = {
      novel_series: value.novel_series,
      season_title: value.season_title,
      author_name: value.author_name,
      about_author: value.about_author,
      season_description: value.season_description,
      sponsor_url: value.sponsor_url,
      season_quarter: value.season_quarter,
      season: value.season,
      status: value.status,
      reads: 0,
      on_going_series:value.on_going_series
    };
    try {
      if (this.id) {
        let thumbnail;
          let coverimage;
          let sponsorimage;
          let sponsorbanner_web;
          // Checking if the cover image is changed if changed the update the image in sapces and also db.
          if (this.cover_image) {
            coverimage = await this.auth.uploadimage('novel/thumbnail/', this.cover_image, false);
            season.cover_image = coverimage['Location'];
          }
          // Checking if the thumbnail image is changed if changed the update the image in sapces and also db.
          if (this.thumbnail_image) {
            thumbnail = await this.auth.uploadimage('novel/cover/', this.thumbnail_image, false);
            season.thumbnail_image = thumbnail['Location'];
          }
          if (this.sponsor_image) {
            sponsorimage = await this.auth.uploadimage('sponser/', this.sponsor_image, false);
            season.sponsor_image = sponsorimage['Location'];
          }
          if (this.sponsor_image_web) {
            sponsorbanner_web = await this.auth.uploadimage('sponser/banner/', this.sponsor_image_web, false);
            season.sponsor_banner_web = sponsorbanner_web['Location'];
          }
          season.IsAllowPointsPurchase = JSON.parse(value.IsAllowPointsPurchase);
        const document = await this.afs.doc(`/Enovelseason/${this.id}`);
        const update = await document.update(season);
        this.toastr.success('Enovel season Added!', 'Success!');
        this.router.navigate(['/novel-seasons']);
      } else {
        if (!this.thumbnail_image) { this.thumbnailimageerror = true; this.loading = false; return false; }
        if (!this.cover_image) { this.coverimageerror = true; this.loading = false; return false; }
        if (!this.sponsor_image) { this.sponsorimageerror = true; this.loading = false; return false; }
        if (!this.sponsor_image_web) { this.sponsorimageerror_Web = true; this.loading = false; return false; }
        // uploading the images to the spaces and getting the uoloaded location
        const thumbnail = await this.auth.uploadimage('novel/thumbnail/', this.thumbnail_image, false);
        const coverimage = await this.auth.uploadimage('novel/cover/', this.cover_image, false);
        const sponsorimage = await this.auth.uploadimage('sponsor/', this.sponsor_image, false);
        const sponsorbanner_web = await this.auth.uploadimage('sponsor/banner/', this.sponsor_image_web, false);
        season.sponsor_banner_web = sponsorbanner_web['Location']
        season.thumbnail_image = thumbnail['Location'];
        season.cover_image = coverimage['Location'];
        season.sponsor_image = sponsorimage['Location'];
        season.IsAllowPointsPurchase = JSON.parse(value.IsAllowPointsPurchase);
        season.pricing_type = 'Free';
        season.admin = this.user.uid;
        season.addedby = this.user.username;
        season.rating = [0, 0, 0, 0, 1];
        season.createdAt = new Date();
        season.date = new Date().toString();
        console.log(season)
        const eseasondata = await this.afs.collection('Enovelseason').add(season);
        const esid = eseasondata.id;
        const id = await this.afs.doc(`/Enovelseason/${esid}`).update({ id: esid });
        this.toastr.success('Enovel season Added!', 'Success!');
        this.router.navigate(['/novel-seasons']);
      }
    } catch (error) {
      this.loading = false;
      this.load = true;
      this.toastr.error('Somthing went wrong please try later!', 'Oops!');
      console.log(error);
    }
  } else {
    this.toastr.error('Somthing went wrong please try later!', 'Oops!');
    console.log('error');
  }
}
  changeListner1(event) {
    if (event.target.files && event.target.files[0]) {
      this.thumbnail_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event:any) => {
        this.thumbnail_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

  changeListner2(event) {
    if (event.target.files && event.target.files[0]) {
      this.cover_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event:any) => {
        this.cover_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

  changeListner3(event) {
    if (event.target.files && event.target.files[0]) {
      this.sponsor_image = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event:any) => {
        this.sponsor_image_url = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }
  changeListner4(event) {
    if (event.target.files && event.target.files[0]) {
      this.sponsor_image_web = event.target.files[0];
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.sponsor_image_url_web = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/E-novels/e-novel-season-add/e-novel-season-add.component.ts